module.exports = __webpack_public_path__ + "static/media/buvidal_logo.235b02d9.svg";